const state = {
    grid_settings: [],
}

export default state;
